/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainer_viewer = {|
  +isAboutTheMakerEnabled: ?boolean;
  +isFavoritesEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSeoLinks_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isAboutTheMakerEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ABOUT_THE_MAKER",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"ABOUT_THE_MAKER\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"FAVORITES\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
